import { icon, IconDefinition } from '@fortawesome/fontawesome-svg-core';

export default function iconToDataUri(
  iconDefinition: IconDefinition,
  {
    color = 'lightgrey',
    scale = 0.75,
  }: { color?: string; scale?: number } = {}, // ? maybe support SVGAttributes['style'] for more customization if needed
) {
  const rendered = icon(iconDefinition, {
    styles: { color, scale: `${scale}` },
  });
  return `data:image/svg+xml,${encodeURIComponent(rendered.html.join(''))}`;
}
